export default __webpack_public_path__ + "static/media/nqphn_logo_white.074a2826.svg";